/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// Tolstoy add-to-cart: fecha o modal e abre o mini-cart.
// Usa APENAS postMessage com filtro de origem (gotolstoy.com) — sem fetch
// interceptor, que disparava para qualquer /cart/add.js da página e causava
// o overlay do mini-cart cobrir o Tolstoy indevidamente.
(function tolstoyCartSync() {
  if (window.__TolstoyCartSync2__) return;
  window.__TolstoyCartSync2__ = true;

  var lastTs = 0;

  function closeAndOpenCart() {
    var now = Date.now();
    if (now - lastTs < 2000) return;
    lastTs = now;

    // 1. Fecha o modal do Tolstoy
    var modal = document.querySelector('[data-test-id="tolstoy-modal"]');
    if (modal) {
      var btn = modal.querySelector(
        '.minimize-tolstoy-modal, [aria-label="Close"][role="button"], button[data-test-id="close-tolstoy-modal"]'
      );
      if (btn) { try { btn.click(); } catch (_) {} }
    }

    // 2. Abre mini-cart após o Tolstoy fechar
    setTimeout(function() {
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (_) {}
      var fn = window.refreshMiniCart || window.requestMiniCartRefresh;
      if (typeof fn === 'function') {
        try { fn({ openMiniCart: true }); return; } catch (_) {}
      }
      var el = document.getElementById('mini-cart');
      if (el && !el.open) {
        try { el.open = true; } catch (_) {}
        if (!el.hasAttribute('open')) el.setAttribute('open', '');
      }
    }, 700);
  }

  // Só aceita mensagens vindas do domínio do Tolstoy.
  // Só reage a _isAddedFromTolstoy === true (sem fuzzy match).
  window.addEventListener('message', function(e) {
    try {
      if (!e.origin || e.origin.indexOf('gotolstoy.com') === -1) return;
      var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      if (!data || typeof data !== 'object') return;
      var items = Array.isArray(data.items) ? data.items : null;
      if (!items) return;
      var added = items.some(function(item) {
        var p = item && item.properties;
        return p && (p._isAddedFromTolstoy === true || p._isAddedFromTolstoy === 'true');
      });
      if (added) closeAndOpenCart();
    } catch (_) {}
  });
})();

(() => {
  const selector = '.product-meta__reference > .konfidency-badges--pdp[data-sku]';
  let topRatedEnabledPromise;
  let activeProductsPromise;

  function isTopRatedEnabled() {
    if (!topRatedEnabledPromise) {
      topRatedEnabledPromise = fetch(`https://reviews-api.konfidency.com.br/paccoby/info?top_rated_check=${Date.now()}`, { cache: 'no-store' })
        .then((response) => {
          if (!response.ok) throw new Error('Konfidency settings unavailable');
          return response.json();
        })
        .then((data) => data?.settings?.topRatedEnabled === true)
        .catch(() => false);
    }
    return topRatedEnabledPromise;
  }

  function getActiveProducts() {
    if (!activeProductsPromise) {
      activeProductsPromise = fetch(`https://reviews-api.konfidency.com.br/paccoby/top-rated/active?top_rated_check=${Date.now()}`, { cache: 'no-store' })
        .then((response) => {
          if (!response.ok) throw new Error('Top Rated unavailable');
          return response.json();
        })
        .catch(() => {
          activeProductsPromise = null;
          return null;
        });
    }
    return activeProductsPromise;
  }

  async function syncProductMediaBadge() {
    const enabled = await isTopRatedEnabled();
    document.documentElement.dataset.paccoTopRatedEnabled = String(enabled);
    const badges = document.querySelectorAll(selector);
    if (!badges.length) return;

    const data = enabled ? await getActiveProducts() : null;
    const activeIds = new Set(Array.isArray(data?.skus) ? data.skus.map(String) : []);
    badges.forEach((badge) => {
      const active = enabled && activeIds.has(badge.dataset.sku);
      badge.classList.toggle('is-top-rated-active', active);
      if (active) {
        badge.setAttribute('role', 'img');
        badge.setAttribute('aria-label', data.badgeLabel || 'Top Rated');
      } else {
        badge.removeAttribute('role');
        badge.removeAttribute('aria-label');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductMediaBadge, { once: true });
  } else {
    syncProductMediaBadge();
  }
  document.addEventListener('product:rerender', () => requestAnimationFrame(syncProductMediaBadge));
  document.addEventListener('shopify:section:load', syncProductMediaBadge);
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.documentElement.dataset.paccoTopRatedEnabled = 'false';
    topRatedEnabledPromise = null;
    activeProductsPromise = null;
    syncProductMediaBadge();
  });
})();

(() => {
  const MOBILE_QUERY = window.matchMedia("(max-width: 740px)");
  const PANEL_SELECTOR = "#predictive-inline-mobile.predictive-inline";
  const MIN_HEIGHT = 180;
  const BASE_GAP = 12;

  let rafId = null;
  let observer = null;
  let viewportBound = false;

  function getViewportHeight() {
    return window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;
  }

  function getBottomGap() {
    const safeArea = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("padding-bottom") || "0"
    ) || 0;

    return BASE_GAP + safeArea;
  }

  function getPanel() {
    return document.querySelector(PANEL_SELECTOR);
  }

  function isVisible(panel) {
    return !!panel && !panel.hasAttribute("hidden") && panel.offsetParent !== null;
  }

  function applyMobilePredictiveBounds() {
    rafId = null;

    if (!MOBILE_QUERY.matches) {
      const panel = getPanel();
      if (panel) {
        panel.style.removeProperty("max-height");
      }
      return;
    }

    const panel = getPanel();
    if (!isVisible(panel)) return;

    const rect = panel.getBoundingClientRect();
    const viewportHeight = getViewportHeight();
    const available = Math.floor(viewportHeight - rect.top - getBottomGap());
    const maxHeight = Math.max(MIN_HEIGHT, available);

    panel.style.maxHeight = `${maxHeight}px`;
  }

  function scheduleApply() {
    if (rafId != null) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(applyMobilePredictiveBounds);
  }

  function bindViewportEvents() {
    if (viewportBound) return;
    viewportBound = true;

    window.addEventListener("resize", scheduleApply, { passive: true });
    window.addEventListener("orientationchange", scheduleApply, { passive: true });
    window.addEventListener("scroll", scheduleApply, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scheduleApply, { passive: true });
      window.visualViewport.addEventListener("scroll", scheduleApply, { passive: true });
    }
  }

  function bindObserver() {
    if (observer) return;

    observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.target instanceof Element && mutation.target.matches(PANEL_SELECTOR)) {
          scheduleApply();
          continue;
        }

        if (mutation.type === "childList") {
          const panel = getPanel();
          if (panel && (panel.contains(mutation.target) || Array.from(mutation.addedNodes).some((node) => node instanceof Element && panel.contains(node)))) {
            scheduleApply();
            continue;
          }
        }
      }
    });

    observer.observe(document.body || document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["hidden", "style", "class"]
    });
  }

  function boot() {
    bindViewportEvents();
    bindObserver();
    scheduleApply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();

(() => {
  function isSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = form.getAttribute("action") || "";
    if (!/\/search(?:$|\?)/.test(action) && !/\/search$/.test(form.action || "")) return false;
    return form.matches(".pacco-search, .predictive-search__form, .main-search__form");
  }

  function stripTypeInputs(form) {
    form.querySelectorAll('input[name="type"]').forEach((input) => {
      input.remove();
    });

    const formId = form.id;
    if (!formId) return;

    document.querySelectorAll(`input[name="type"][form="${CSS.escape(formId)}"]`).forEach((input) => {
      input.remove();
    });
  }

  function stripTypeFromAction(form) {
    try {
      const actionUrl = new URL(form.action || "/search", window.location.origin);
      actionUrl.searchParams.delete("type");
      form.action = `${actionUrl.pathname}${actionUrl.search}${actionUrl.hash}`;
    } catch (_) {
    }
  }

  function normalizeSearchQuery(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const raw = String(input.value || "").trim().replace(/\s+/g, " ");
    if (!raw) return;

    input.value = raw.replace(/\S+/g, (word) => {
      if (/[A-ZÀ-Þ]/.test(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  }

  function ensureProductSearchType(form) {
    let input = form.querySelector('input[name="type"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "type";
      form.appendChild(input);
    }
    input.value = "product";
  }

  function getPredictiveContainerForForm(form) {
    const input = form.querySelector('input[is="predictive-search-input"][aria-controls], input[name="q"][aria-controls]');
    if (input) {
      const controlled = document.getElementById(input.getAttribute("aria-controls"));
      if (controlled) return controlled;
    }

    if (form.id) {
      const drawer = document.getElementById("search-drawer");
      if (drawer && drawer.contains(form)) {
        return drawer.querySelector(".predictive-search__results, .predictive-inline, #pacco-psx") || drawer;
      }
    }

    return null;
  }

  function isContainerVisible(container) {
    return !!container && !container.hasAttribute("hidden") && container.offsetParent !== null;
  }

  function getFirstVisibleGenericResult(container) {
    if (!isContainerVisible(container)) return null;

    const productResult = container.querySelector(
      '.predictive-search__results-categories-item:not([hidden]) [data-type="products"] a, [data-type="products"] a'
    );

    if (productResult) return { href: null, hasProduct: true };

    const genericResult = container.querySelector(
      '.predictive-search__results-categories-item:not([hidden]) [data-type="pages"] a, ' +
      '.predictive-search__results-categories-item:not([hidden]) [data-type="articles"] a, ' +
      '.predictive-search__results-categories-item:not([hidden]) [data-type="collections"] a, ' +
      '[data-type="pages"] a, [data-type="articles"] a, [data-type="collections"] a'
    );

    return { href: genericResult ? genericResult.href : null, hasProduct: false };
  }

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!isSearchForm(form)) return;

    const predictiveContainer = getPredictiveContainerForForm(form);
    const predictiveState = getFirstVisibleGenericResult(predictiveContainer);

    stripTypeInputs(form);
    stripTypeFromAction(form);
    normalizeSearchQuery(form);
    ensureProductSearchType(form);

    if (predictiveState && !predictiveState.hasProduct && predictiveState.href) {
      event.preventDefault();
      window.location.href = predictiveState.href;
    }
  }, true);
})();

// Blue Tag: dispara basket event quando ocorre add to cart.
// Usa o padrão exato exigido pelo Blue (getblue.io):
//   setCampaignId + setProductId (string) + setPageType "basket"
// O productList vem do __st (Shopify analytics) via "rid" ou do
// response do /cart/add.js (product_id).
(function blueTagCartAddTracking() {
  if (window.__blueTagCartAddTracking__) return;
  window.__blueTagCartAddTracking__ = true;

  var CAMPAIGN_ID = 'D185FB3A-A7B9-B0F2-F9BD8D78C4B4EFB7';
  var BLUE_TAG_SRC = '//event.getblue.io/js/blue-tag.min.js';
  var ADD_ENDPOINT_RE = /(^|\/)(cart\/add)(\.js)?(\?|$)/i;

  /* ---- debug (?blue_tag_debug=1) ---- */
  if (typeof window.BLUE_TAG_DEBUG === 'undefined') {
    window.BLUE_TAG_DEBUG = /[?&]blue_tag_debug=1/i.test(window.location.search);
  }
  function log() {
    if (!window.BLUE_TAG_DEBUG || !window.console) return;
    try { console.log.apply(console, ['[BlueTagCart]'].concat(Array.prototype.slice.call(arguments))); } catch (_) {}
  }

  /* ---- Extrai product ID numérico do script __st (Shopify analytics) ---- */
  function getProductIdFromST() {
    try {
      var el = document.getElementById('__st');
      if (!el) return null;
      var txt = el.textContent || el.innerText || '';
      var m = txt.match(/"rid":(\d+)/);
      return m ? m[1] : null;
    } catch (_) { return null; }
  }

  /* ---- Garante que o script blue-tag.min.js está carregado ---- */
  function ensureBlueTagScript(cb) {
    if (document.querySelector('script[src*="event.getblue.io/js/blue-tag.min.js"]')) {
      if (cb) cb();
      return;
    }
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = BLUE_TAG_SRC;
    if (cb) s.onload = cb;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ====================================================================
     CORE: dispara o Blue tag no formato exato exigido
     setProductId recebe STRING (não array), igual ao template deles.
     ==================================================================== */
  var _lastFiredAt = 0;

  function fireBlueBasketTag(productId) {
    if (!productId) { log('fireBlueBasketTag: no productId'); return; }
    var now = Date.now();
    if (now - _lastFiredAt < 500) { log('dedupe skip'); return; }
    _lastFiredAt = now;

    var pid = String(productId);
    log('firing basket tag, productId =', pid);

    // 1) Push dataLayer para GTM (evento add_to_cart + productList como string)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      productList: pid
    });

    // 2) Dispara blue_q no formato exato exigido
    ensureBlueTagScript(function() {
      window.blue_q = window.blue_q || [];
      window.blue_q.push(
        { event: 'setCampaignId', value: CAMPAIGN_ID },
        { event: 'setProductId',  value: pid },
        { event: 'setPageType',   value: 'basket' }
      );
      log('blue_q pushed: basket', pid);
    });

    // Também pusha imediatamente caso o script já esteja carregado
    window.blue_q = window.blue_q || [];
    window.blue_q.push(
      { event: 'setCampaignId', value: CAMPAIGN_ID },
      { event: 'setProductId',  value: pid },
      { event: 'setPageType',   value: 'basket' }
    );
  }

  /* ---- Resolve o productId: tenta response do add, senão __st, senão /cart.js ---- */
  function resolveAndFire(responseProductId) {
    // 1) Se veio do response do /cart/add.js, usa direto
    if (responseProductId) {
      fireBlueBasketTag(responseProductId);
      return;
    }
    // 2) Tenta pegar do __st (funciona na PDP)
    var stId = getProductIdFromST();
    if (stId) {
      fireBlueBasketTag(stId);
      return;
    }
    // 3) Fallback: busca /cart.js e pega o último item adicionado
    log('fallback: fetching /cart.js');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
        var lastItem = cart.items[cart.items.length - 1];
        if (lastItem && lastItem.product_id) {
          fireBlueBasketTag(String(lastItem.product_id));
        }
      })
      .catch(function(e) { log('cart.js fallback error', e); });
  }

  /* ====================================================================
     HOOK 1: Intercepta fetch('/cart/add.js') e lê o product_id da response
     ==================================================================== */
  (function hookFetch() {
    if (window.__blueTagCartFetchHook__) return;
    if (!window.fetch) return;
    window.__blueTagCartFetchHook__ = true;

    var origFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url || '');
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isAdd = ADD_ENDPOINT_RE.test(url) && String(method).toUpperCase() !== 'GET';

      if (!isAdd) return origFetch.apply(this, arguments);

      log('intercepted fetch', url);
      return origFetch.apply(this, arguments).then(function(response) {
        if (response && response.ok) {
          response.clone().json().then(function(json) {
            var items = json && json.items ? json.items : (json && json.product_id ? [json] : []);
            var pid = null;
            for (var i = 0; i < items.length; i++) {
              if (items[i] && items[i].product_id) { pid = String(items[i].product_id); break; }
            }
            log('fetch /cart/add.js product_id =', pid);
            resolveAndFire(pid);
          }).catch(function() {
            log('fetch parse fail, trying __st');
            resolveAndFire(null);
          });
        }
        return response;
      });
    };
  })();

  /* ====================================================================
     HOOK 2: Intercepta XHR para /cart/add.js (legado)
     ==================================================================== */
  (function hookXHR() {
    var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!proto || proto.__blueTagHooked__) return;
    proto.__blueTagHooked__ = true;

    var origOpen = proto.open;
    var origSend = proto.send;

    proto.open = function(method, url) {
      this.__btWatch = ADD_ENDPOINT_RE.test(url) && String(method).toUpperCase() !== 'GET';
      return origOpen.apply(this, arguments);
    };
    proto.send = function() {
      if (this.__btWatch) {
        var xhr = this;
        var done = function() {
          xhr.removeEventListener('load', done);
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              var json = JSON.parse(xhr.responseText);
              var items = json && json.items ? json.items : (json && json.product_id ? [json] : []);
              var pid = items[0] && items[0].product_id ? String(items[0].product_id) : null;
              resolveAndFire(pid);
            } catch (_) { resolveAndFire(null); }
          }
        };
        this.addEventListener('load', done);
      }
      return origSend.apply(this, arguments);
    };
  })();

  /* ====================================================================
     HOOK 3: Eventos do tema — variant:added, product:added, cart-add
     ==================================================================== */
  function onVariantAdded(event) {
    var variant = event && event.detail && event.detail.variant;
    var pid = variant && variant.product_id ? String(variant.product_id) : null;
    log('variant:added', pid || '(no detail)');
    resolveAndFire(pid);
  }

  document.addEventListener('variant:added', onVariantAdded);
  document.documentElement.addEventListener('variant:added', onVariantAdded);
  document.addEventListener('product:added', function(e) {
    var v = e && e.detail && e.detail.variant;
    resolveAndFire(v && v.product_id ? String(v.product_id) : null);
  });
  document.addEventListener('cart-add', function() { resolveAndFire(null); });

  log('init — hooks: fetch + XHR + variant:added + product:added + cart-add + __st');
})();

// Preserve Konfidency rating badge through product meta rerenders
(function keepKonfidencyBadgeStable(){
  const HOST_SELECTOR = '.product-meta__reference';
  const BADGE_SELECTORS = [
    '.product-meta__reviews-badge.hidden-lap-and-up',
    '.product-meta__reviews-badge.hidden-pocket'
  ];
  const cssEscape = (window.CSS && typeof CSS.escape === 'function')
    ? CSS.escape
    : (value) => String(value).replace(/([ #.;,*+~'"\\/:^$=!<>|()[\]{}-])/g, '\\$1');

  const boundForms = new WeakSet();

  function snapshotBadges(container){
    if (!container) return [null, null];
    return BADGE_SELECTORS.map(selector => {
      const node = container.querySelector(selector);
      return node ? node.cloneNode(true) : null;
    });
  }

  function injectBadges(container, cache){
    if (!container || !cache) return;
    cache.forEach((cachedNode, idx) => {
      if (!cachedNode) return;
      const clone = cachedNode.cloneNode(true);
      const existing = container.querySelector(BADGE_SELECTORS[idx]);
      if (existing) {
        existing.replaceWith(clone);
      } else {
        const sku = container.querySelector('.product-meta__sku');
        if (sku) sku.insertAdjacentElement('beforebegin', clone);
        else container.appendChild(clone);
      }
    });
  }

  function bindForMeta(metaEl){
    if (!metaEl) return;
    const formId = metaEl.getAttribute('observe-form');
    if (!formId) return;

    const form = document.forms[formId];
    if (!form || boundForms.has(form)) return;

    const metaSelector = `product-meta[observe-form="${cssEscape(formId)}"]`;
    let cache = snapshotBadges(metaEl.querySelector(HOST_SELECTOR));

    const handler = (event) => {
      const fragment = event?.detail?.htmlFragment;
      if (!fragment) return;

      const currentMeta = document.querySelector(metaSelector);
      const currentHost = currentMeta?.querySelector(HOST_SELECTOR);
      if (currentHost) cache = snapshotBadges(currentHost);

      const nextHost = fragment.querySelector(HOST_SELECTOR);
      if (!nextHost) return;
      if (!cache?.some(Boolean)) return;

      injectBadges(nextHost, cache);

      requestAnimationFrame(() => {
        const refreshedMeta = document.querySelector(metaSelector);
        const refreshedHost = refreshedMeta?.querySelector(HOST_SELECTOR);
        if (refreshedHost) cache = snapshotBadges(refreshedHost);
      });
    };

    form.addEventListener('product:rerender', handler, true);
    boundForms.add(form);
  }

  function init(scope = document){
    scope.querySelectorAll('product-meta[observe-form]').forEach(bindForMeta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event?.target || document);
  }, true);
})();

(function(){
  const FLAG = '__paccoInitialVariantSynced';
  const MAX_RETRIES = 5;

  function hasVariantParam() {
    return new URLSearchParams(window.location.search).has('variant');
  }

  function collectOptionValues(picker) {
    const formId = picker?.getAttribute('form-id');
    if (!formId) return [];
    const form = document.forms[formId];
    if (!form) return [];

    const entries = [];
    const fields = form.querySelectorAll('input[data-option-position], select[data-option-position]');
    fields.forEach((field) => {
      const position = parseInt(field.getAttribute('data-option-position') || '0', 10) || 0;
      let value;

      if (field.matches('select')) {
        value = field.value;
      } else if (field.type === 'radio' || field.type === 'checkbox') {
        if (!field.checked) return;
        value = field.value;
      } else {
        value = field.value;
      }

      if (value === undefined || value === null || value === '') return;
      entries.push({ position, value });
    });

    entries.sort((a, b) => a.position - b.position);
    return entries.map(({ value }) => value);
  }

  function runSync(attempt = 0) {
    if (hasVariantParam()) return;

    // PDP: não forçar selectCombination no carregamento inicial.
    // O tema já renderiza a variante inicial via Liquid + VariantPicker.
    // Forçar esse sync dispara um segundo ciclo de variant:change/product:rerender,
    // causando flash de mídia de outras variantes antes de estabilizar.
    if (document.querySelector('product-media[initial-variant-id]')) return;

    const picker = document.querySelector('variant-picker[handle]');
    if (!picker || picker[FLAG]) return;

    const optionValues = collectOptionValues(picker);
    if (!optionValues.length) {
      if (attempt < MAX_RETRIES) setTimeout(() => runSync(attempt + 1), 100);
      return;
    }

    if (typeof picker.selectCombination !== 'function') {
      if (window.customElements?.whenDefined && attempt < MAX_RETRIES) {
        window.customElements.whenDefined('variant-picker').then(() => {
          requestAnimationFrame(() => runSync(attempt + 1));
        });
      }
      return;
    }

    picker[FLAG] = true;
    try {
      picker.selectCombination({ optionValues, productChange: false });
    } catch (err) {
      console.warn('[initial-variant-sync] Failed to sync initial variant', err);
    }
  }

  function init() {
    requestAnimationFrame(() => runSync());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init, true);
})();

// =====================================================
// PACCO Customizer Add-to-Cart Interceptor
// Abre o mini-cart após produtos com personalização serem adicionados
// =====================================================
(function paccoCustomizerMiniCartSync(){
  if (window.__PaccoCustomizerMiniCartSync__) return;
  window.__PaccoCustomizerMiniCartSync__ = true;

  const ADD_ENDPOINT_RE = /(^|\/)cart\/add(\.js)?(\?|$)/i;
  let lastAddTs = 0;

  function hasPplrMarker(items){
    if (!Array.isArray(items) || !items.length) return false;
    return items.some(item => {
      const props = item && item.properties;
      if (!props) return false;
      // Verifica se é um item do Pacco Customizer
      return Object.keys(props).some(key => {
        return key.includes('_pplr') || 
               key.includes('_pc_pricing') || 
               key === 'ESCOLHA O SEU CRISTAL' ||
               key === 'Visualizar' ||
               key === '_Visualizar';
      });
    });
  }

  function openMiniCartWithAnimation(){
    // Usa a função nativa do tema que já cuida de tudo: refresh + abertura com animação
    if (typeof window.refreshMiniCart === 'function') {
      window.refreshMiniCart({ openMiniCart: true, keepDiscountOpen: false });
      return;
    }
    
    // Fallback para requestMiniCartRefresh
    if (typeof window.requestMiniCartRefresh === 'function') {
      window.requestMiniCartRefresh({ openMiniCart: true });
      return;
    }
    
    // Fallback final: abre diretamente
    const drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    
    drawer.classList.remove('drawer--no-anim');
    drawer.clientWidth;
    try { drawer.open = true; } catch(_) {}
    drawer.setAttribute('open', '');
    drawer.classList.add('is-open', 'active', 'drawer--active', 'open');
    document.body.classList.add('overflow-hidden');
  }

  function handlePplrPayload(payload){
    let items = null;
    if (!payload) return false;
    if (Array.isArray(payload)) items = payload;
    else if (Array.isArray(payload.items)) items = payload.items;
    else if (payload.item) items = [payload.item];
    
    if (!hasPplrMarker(items || [])) return false;
    
    const now = Date.now();
    if (now - lastAddTs < 1000) return true;
    lastAddTs = now;
    
    // Aguarda um pouco e abre o mini-cart
    setTimeout(() => {
      openMiniCartWithAnimation();
    }, 500);
    return true;
  }

  // Intercepta XMLHttpRequest
  if (typeof XMLHttpRequest !== 'undefined') {
    const proto = XMLHttpRequest.prototype;
    const originalOpen = proto.open;
    const originalSend = proto.send;

    proto.open = function pplrOpen(method, url){
      this.__pplrWatch = method && String(method).toUpperCase() === 'POST' && ADD_ENDPOINT_RE.test(url || '');
      return originalOpen.apply(this, arguments);
    };

    proto.send = function pplrSend(body){
      if (this.__pplrWatch) {
        const handle = () => {
          this.removeEventListener('load', handle);
          if (this.status < 200 || this.status >= 300) return;
          let payload = null;
          try {
            const responseType = this.responseType;
            if (responseType === '' || responseType === 'text' || responseType === undefined || responseType === null) {
              payload = this.responseText;
            } else if (responseType === 'json') {
              payload = this.response;
            }
            if (typeof payload === 'string') {
              try { payload = JSON.parse(payload); } catch (_) { payload = null; }
            }
          } catch (err) {
            console.warn('[PaccoCustomizerMiniCart] failed to inspect response', err);
          }
          if (payload) handlePplrPayload(payload);
        };
        this.addEventListener('load', handle);
      }
      return originalSend.apply(this, arguments);
    };
  }

  // Escuta evento de page refresh para abrir o mini-cart após reload
  if (sessionStorage.getItem('__pplrOpenMiniCart') === 'true') {
    sessionStorage.removeItem('__pplrOpenMiniCart');
    
    function openAfterLoad(){
      setTimeout(() => {
        openMiniCartWithAnimation();
      }, 500);
    }
    
    if (document.readyState === 'complete') {
      openAfterLoad();
    } else {
      window.addEventListener('load', openAfterLoad);
    }
  }
})();

/* ============================================================
   PACCO x TOLSTOY — 8 iniciais + "Ver mais" em lotes
   - Sem alterar HTML do tema
   - Remove botão duplicado se existir
   - Recalcula itens a cada clique (Tolstoy é async)
   ============================================================ */

(() => {
  const INITIAL = 8;
  const STEP = 8;

  const ROOT_CLASS = "pacco-tolstoy-root";
  const HIDDEN_CLASS = "pacco-tolstoy-hidden";

  const WRAP_CLASS = "pacco-tolstoy-load-more-wrap";
  const BTN_CLASS = "pacco-tolstoy-load-more-btn";

  function $all(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function cleanupDuplicateButtons(scope) {
    const wraps = $all(`.${WRAP_CLASS}`, scope);
    if (wraps.length <= 1) return;
    wraps.slice(1).forEach(w => w.remove());
  }

  function ensureSingleRoot(carouselEl) {
    const inner = carouselEl.querySelector(".tolstoy-carousel-container");
    if (inner && inner.classList.contains(ROOT_CLASS)) {
      inner.classList.remove(ROOT_CLASS);
      inner.removeAttribute("data-pacco-load-more");
      inner.removeAttribute("data-pacco-tolstoy-init");
    }
  }

  function getTrack(carouselEl) {
    return carouselEl.querySelector(".tolstoy-carousel-videos-container");
  }

  function getItems(trackEl) {
    if (!trackEl) return [];
    const direct = Array.from(trackEl.children || []).filter(el =>
      el.classList && el.classList.contains("tolstoy-carousel-tile-container")
    );
    return direct.length ? direct : $all(".tolstoy-carousel-tile-container", trackEl);
  }

  function applyVisibility(items, visibleCount) {
    items.forEach((it, idx) => {
      if (idx < visibleCount) it.classList.remove(HIDDEN_CLASS);
      else it.classList.add(HIDDEN_CLASS);
    });
  }

  function shouldShowButton(items, visibleCount) {
    return items.length > visibleCount;
  }

  function removeButton(scope) {
    const wrap = scope.querySelector(`.${WRAP_CLASS}`);
    if (wrap) wrap.remove();
  }

  function upsertButton(carouselEl) {
    const scope = carouselEl.closest(".shopify-app-block") || carouselEl.parentElement || document.body;

    cleanupDuplicateButtons(scope);

    const track = getTrack(carouselEl);
    const items = getItems(track);
    if (!items.length) {
      removeButton(scope);
      return;
    }

    // estado atual
    let visible = Number(carouselEl.dataset.paccoVisible || Math.min(INITIAL, items.length));
    if (!Number.isFinite(visible) || visible < 0) visible = Math.min(INITIAL, items.length);
    if (visible > items.length) visible = items.length;

    // aplica visibilidade sempre (Tolstoy muda o DOM)
    carouselEl.dataset.paccoVisible = String(visible);
    applyVisibility(items, visible);

    // se não tem mais nada escondido, remove botão
    if (!shouldShowButton(items, visible)) {
      removeButton(scope);
      return;
    }

    // cria/garante botão único
    let wrap = scope.querySelector(`.${WRAP_CLASS}`);
    let btn = wrap ? wrap.querySelector(`.${BTN_CLASS}`) : null;

    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = WRAP_CLASS;

      btn = document.createElement("a");
      btn.href = "javascript:void(0)";
      btn.className = `button button--primary ${BTN_CLASS}`;
      btn.textContent = "Ver mais";

      wrap.appendChild(btn);
      carouselEl.insertAdjacentElement("afterend", wrap);
    } else if (!btn) {
      btn = document.createElement("a");
      btn.href = "javascript:void(0)";
      btn.className = `button button--primary ${BTN_CLASS}`;
      btn.textContent = "Ver mais";
      wrap.appendChild(btn);
    }

    cleanupDuplicateButtons(scope);

    // listener (recalcula a cada clique)
    if (btn.dataset.paccoBound !== "1") {
      btn.dataset.paccoBound = "1";

      btn.addEventListener("click", () => {
        const trackNow = getTrack(carouselEl);
        const itemsNow = getItems(trackNow);
        if (!itemsNow.length) {
          removeButton(scope);
          return;
        }

        const curr = Number(carouselEl.dataset.paccoVisible || Math.min(INITIAL, itemsNow.length));
        const next = Math.min(itemsNow.length, curr + STEP);

        carouselEl.dataset.paccoVisible = String(next);
        applyVisibility(itemsNow, next);

        // só some se realmente não tiver mais escondido
        if (!shouldShowButton(itemsNow, next)) {
          removeButton(scope);
        }
      });
    }
  }

  function initCarousel(carouselEl) {
    if (!carouselEl || carouselEl.nodeType !== 1) return false;

    carouselEl.classList.add(ROOT_CLASS);
    ensureSingleRoot(carouselEl);

    const track = getTrack(carouselEl);
    if (!track) return false;

    const items = getItems(track);
    if (!items.length) return false;

    if (!carouselEl.dataset.paccoVisible) {
      carouselEl.dataset.paccoVisible = String(Math.min(INITIAL, items.length));
    }

    upsertButton(carouselEl);

    carouselEl.dataset.paccoTolstoyInit = "1";
    return true;
  }

  function boot() {
    const carousels = $all("tolstoy-carousel");
    if (!carousels.length) return;
    carousels.forEach(c => initCarousel(c));
  }

  let bootRaf = null;
  let domObserver = null;

  function scheduleBoot() {
    if (bootRaf != null) return;
    bootRaf = requestAnimationFrame(() => {
      bootRaf = null;
      boot();
    });
  }

  function isTolstoyMutation(mutation) {
    const target = mutation && mutation.target;
    if (target instanceof Element && (target.matches("tolstoy-carousel") || target.closest("tolstoy-carousel"))) {
      return true;
    }

    const addedNodes = mutation && mutation.addedNodes ? mutation.addedNodes : [];
    for (const node of addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches("tolstoy-carousel") || node.closest("tolstoy-carousel") || node.querySelector("tolstoy-carousel")) {
        return true;
      }
    }

    return false;
  }

  function bindTolstoyObserver() {
    const root = document.body || document.documentElement;
    if (!root || domObserver) return;

    domObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (!isTolstoyMutation(mutation)) continue;
        scheduleBoot();
        break;
      }
    });

    domObserver.observe(root, { childList: true, subtree: true });

    // Evita manter um observer global permanente quando o widget não está ativo.
    setTimeout(() => {
      if (!domObserver) return;
      const hasCarousel = !!document.querySelector("tolstoy-carousel");
      if (hasCarousel) return;
      domObserver.disconnect();
      domObserver = null;
    }, 10000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      boot();
      bindTolstoyObserver();
    }, { once: true });
  } else {
    boot();
    bindTolstoyObserver();
  }
})();
